import {ResponsiveBar} from '@nivo/bar'
import {useEffect, useState} from "react";

export function BarGraph({data, colors, format, colorList, xName, yName, keys, xIndex, yIndex, height, borderRadius, innerPadding, labelFun, colorBy, margin, minValue, maxValue, xAxisRotation}) {

    const [graphData, setGraphData] = useState([]);


    function formatData() {
        const temp = [];

        for(let i = 0; i < data.groups.length; i++) {
            temp[i] = data.groups[i].data
            temp[i]["group"] = data.groups[i].group
        }
        setGraphData(temp.reverse())
        //
        // setInterval(() => {
        //     console.log("Hello")
        //     let copy = [...graphData]
        //     Object.keys(graphData[0]).forEach(item => {
        //         if(item != "group") {
        //             copy[item] += Math.random()*20;
        //         }
        //     })
        //     console.log(copy)
        //     setGraphData(copy)
        // }, 10000)
    }


    useEffect(() => {
        if(data != null) {
            formatData()
        }
    }, [data]);




    return (
        <div style={{minHeight: height, height: height}} className={"w-100"}>
            <ResponsiveBar
                colors={{scheme: format.colors != null ? format.colors : "nivo"}}
                colorBy={colorBy ?? "id"}
                groupMode={format.stacked ? "stacked" : "grouped"}
                borderRadius={borderRadius ?? 0}
                data={graphData}
                keys={keys}
                enableGridX={true}
                enableGridY={false}
                indexBy={xIndex}
                margin={margin ?? {top: 50, right: 80, bottom: 80, left: 100}}
                padding={0.2}
                innerPadding={innerPadding ?? 0}
                animate={true}
                motionConfig={"slow"}
                layout={format.horizontal ? "horizontal" : "vertical"}
                valueScale={{type: 'linear', min:minValue, max:maxValue}}
                indexScale={{type: 'band', round: true}}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}
                axisTop={null}
                axisRight={null}
                axisBottom={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: (xAxisRotation ?? 0),
                    legend: yName,
                    legendPosition: 'middle',
                    legendOffset: 32,
                    truncateTickAt: 0
                }}
                axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: xName,
                    legendPosition: 'middle',
                    legendOffset: -40,
                    truncateTickAt: 0
                }}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            1.6
                        ]
                    ]
                }}
                label={labelFun ?? ((item) => `${item.id}`)}
                role="application"

            />
        </div>
    )
}